import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type {
	CreateSlaPolicyArgs,
	DeleteSlaPolicyArgs,
	ReorderSlaPoliciesArgs,
	UpdateSlaPolicyArgs,
} from "../types"
import type { JSONValue } from "@rocicorp/zero"

export const slaPolicyMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateSlaPolicyArgs
			ctx: ZeroJwtPayload
		}) => {
			const [existing] = await tx.query.slaPolicies
				.where("id", "=", args.id)
				.run()

			if (existing) {
				throw new Error("SlaPolicy already exists")
			}

			await tx.mutate.slaPolicies.insert({
				id: args.id,
				name: args.name,
				conditions: args.conditions as unknown as JSONValue | undefined,
				position: args.position,
				firstResponseMinutes: args.firstResponseMinutes ?? undefined,
				nextResponseMinutes: args.nextResponseMinutes ?? undefined,
				timeToCloseMinutes: args.timeToCloseMinutes ?? undefined,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				isDeleted: false,
				version: 1,
				workspaceId: authData.workspaceId,
			})
		},
	),
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateSlaPolicyArgs }) => {
			await tx.mutate.slaPolicies.update({
				...args,
				conditions: args.conditions as unknown as JSONValue | undefined,
				firstResponseMinutes: args.firstResponseMinutes ?? undefined,
				nextResponseMinutes: args.nextResponseMinutes ?? undefined,
				timeToCloseMinutes: args.timeToCloseMinutes ?? undefined,
			})
		},
	),
	reorder: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: ReorderSlaPoliciesArgs }) => {
			for (let i = 0; i < args.policyIds.length; i++) {
				await tx.mutate.slaPolicies.update({
					id: args.policyIds[i]!,
					position: i,
				})
			}
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteSlaPolicyArgs }) => {
			await tx.mutate.slaPolicies.delete({ id: args.id })
		},
	),
}
